import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import SmartRender from "containers/SmartRender";

const PrivacyPolicyHOC = Component =>
  function Comp(props) {
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch => {
  return {};
};

export const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(PrivacyPolicyHOC(SmartRender));
